export const InvoiceStatus = {
    PAID: 'paid',
    PENDING: 'pending',
    ALL: 'all'
};
